import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const reasons = [
  "A voice-first way to find your things",
  "Made to feel responsive, not robotic",
  "Designed for families, not just gadget fans",
  "A calmer alternative to map-based trackers",
];

const SocialProof = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/waitlist/stats`)
      .then((r) => setCount(r.data?.total ?? 0))
      .catch(() => setCount(0));
  }, []);

  return (
    <section
      data-testid="social-proof-section"
      className="relative py-24 bg-[#FAFAFA] border-y border-zinc-200/70"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.2em] uppercase text-zinc-500 font-medium">Early Interest</p>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-semibold tracking-tight leading-[1.1]">
              Why people want things that talk back
            </h2>
            {count !== null && (
              <div className="mt-6 inline-flex items-center gap-3 rounded-full glass px-4 py-2" data-testid="waitlist-count">
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                <span className="text-sm text-zinc-700">
                  <span className="font-semibold">{count}</span> people already on the waitlist
                </span>
              </div>
            )}
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3">
            {reasons.map((r, i) => (
              <div
                key={r}
                data-testid={`reason-${i}`}
                className="rounded-2xl bg-white border border-zinc-200/80 p-5"
              >
                <div className="font-display text-base md:text-lg tracking-tight">{r}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
